import script from "./SmsCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsCenter.vue?vue&type=script&setup=true&lang=js"

import "./SmsCenter.vue?vue&type=style&index=0&id=b0e49808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e49808"]])

export default __exports__